__turbopack_context__.v({
  "backButton": "ClientPurchaseModal-module__PDTwFq__backButton",
  "closeButton": "ClientPurchaseModal-module__PDTwFq__closeButton",
  "closeButtonTopRight": "ClientPurchaseModal-module__PDTwFq__closeButtonTopRight",
  "globalErrorText": "ClientPurchaseModal-module__PDTwFq__globalErrorText",
  "loadingOverlayModalLevel": "ClientPurchaseModal-module__PDTwFq__loadingOverlayModalLevel",
  "modalContent": "ClientPurchaseModal-module__PDTwFq__modalContent",
  "modalOverlay": "ClientPurchaseModal-module__PDTwFq__modalOverlay",
  "paymentButton": "ClientPurchaseModal-module__PDTwFq__paymentButton",
  "paymentMethodSelector": "ClientPurchaseModal-module__PDTwFq__paymentMethodSelector",
  "selectionContainer": "ClientPurchaseModal-module__PDTwFq__selectionContainer",
  "selectionTitle": "ClientPurchaseModal-module__PDTwFq__selectionTitle",
  "spin": "ClientPurchaseModal-module__PDTwFq__spin",
  "spinner": "ClientPurchaseModal-module__PDTwFq__spinner",
  "unavailableLabel": "ClientPurchaseModal-module__PDTwFq__unavailableLabel",
});
